
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sustainability/remixed",
      function () {
        return require("private-next-pages/sustainability/remixed/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sustainability/remixed"])
      });
    }
  